import { isEmpty } from 'rxjs/operator/isEmpty';
import { TableModule } from 'primeng/table';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TipoReunioesEnum } from '../../shared/dominios/enum/tipo-reunioes.enum';
import { AdministrativoService } from '../service/administrativo.service';
import { TipoReuniaoModel } from '../../shared/models/tipo-reuniao.model';
import { ReuniaoModel } from '../../shared/models/reuniao.model';
import { AnexoReuniaoModel } from '../../shared/models/anexo-reuniao.model';
import { PautasReunioesTelaDTO } from '../../shared/dominios/DTO/pautas-reunioes-tela.DTO';
import { ToastrService } from 'ngx-toastr';

import * as JSZip from 'jszip';
import * as  FileSaver from 'file-saver';
import { MessageUtil } from '../../shared/messages/messageUtil';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-pautas-reunioes',
  templateUrl: './pautas-reunioes.component.html',
  styleUrls: ['./pautas-reunioes.component.css']
})
export class PautasReunioesComponent implements OnInit {


  @BlockUI() blockUi: NgBlockUI;

  pathLocal: number;
  param: string;

  tipoReuniaoModel = new TipoReuniaoModel();
  reuniaoModel: ReuniaoModel[] = [];

  anexoReuniaoModel: AnexoReuniaoModel[] = [];

  situacaoLeberarInternet = 3;

  telaTabela: PautasReunioesTelaDTO[] = [];

  page = 0;
  rows = 10;
  totalRecords = 0;

  constructor(
    private activatedRoute: ActivatedRoute,
    private toastrService: ToastrService,
    private router: Router,
    private administrativoService: AdministrativoService
  ) {
    this.activatedRoute.url
      .subscribe(arg => this.pathLocal = TipoReunioesEnum.getId(arg[1]['path'].toUpperCase()));
  }


  ngOnInit() {
    this.param = '/cardMenus/cardMenuAdministrativo';
    this.getTipoReuniao();
    this.getReunioesByTipoESituacao();
  }

  async getTipoReuniao() {
    this.tipoReuniaoModel = await this.administrativoService.getTipoReuniao(this.pathLocal);
  }

  paginacao(evento): void {

    this.page = evento['page'];
    this.rows = evento['rows'];
    this.getReunioesByTipoESituacao();
  }

  async getReunioesByTipoESituacao() {
    try {
      this.reuniaoModel = await this.administrativoService.getReunioesByTipoESituacao(this.pathLocal, this.situacaoLeberarInternet, this.rows, this.page);
      this.totalRecords = this.reuniaoModel['totalElements'];
      this._buscarAnexosReunioes();
    } catch (error) {
       this.router.navigate([this.param])
      this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO);
    }
  }

  async getAnexoByReuniao(reuniaoModel: ReuniaoModel) {
    this.anexoReuniaoModel = [];
    this.anexoReuniaoModel = await this.administrativoService.getAnexoByReuniao(Number(reuniaoModel.tpReuniao), reuniaoModel.sqReuniao);
    this.anexoReuniaoModel = this._ordenaListaConteudo(this.anexoReuniaoModel);
    this._popularTabelaTela(reuniaoModel);
  }

  private _buscarAnexosReunioes(): void {
    this.telaTabela = [];
    this.reuniaoModel['content'].map(item => {
      this.getAnexoByReuniao(item);
    })

  }

  public tipoReuniao(tpReuniao){
     return tpReuniao == "4" ? true : false;
  }



  async baixarTudo(itemA) {
    const zip: JSZip = new JSZip();
    this.blockUi.start('Carregando...');
    for (let i = 0; i < itemA.value.length; i++) {
      const documentoRetorno: any = await this.administrativoService.downloadDocumento(Number(itemA.value[i].tpReuniao), itemA.value[i].sqReuniao, itemA.value[i].sqAnexo);
      zip.file(itemA.value[i].dsAnexo, documentoRetorno, { base64: true });
    }

    zip.generateAsync({ type: 'blob' })
    .then(function (content) {
      FileSaver.saveAs(content, itemA.key);
    }).then(() => this.blockUi.stop()).catch(() => this.blockUi.stop())


  }

  public verificaSeExisteArquivosRCI(itemA){
    let listRci: any;
    for(let i = 0; i < itemA.value.length; i++ ){
      const rci = itemA.value[i].noAnexo.substr(0,3).toUpperCase();
      if(rci == 'RCI'){
         listRci = rci; 
      }
    }
    return listRci == 'RCI' ? true: false;
  }

  async baixarArquivosRCI(itemA) {
    const zip: JSZip = new JSZip();
    this.blockUi.start('Carregando...');
  
    for (let i = 0; i < itemA.value.length; i++) {
      const anexoRci = itemA.value[i].noAnexo.substr(0,3).toUpperCase();
        if(anexoRci == 'RCI'){
        const documentoRetorno: any = await this.administrativoService.downloadDocumento(Number(itemA.value[i].tpReuniao), itemA.value[i].sqReuniao, itemA.value[i].sqAnexo);
        zip.file(itemA.value[i].dsAnexo, documentoRetorno, { base64: true });  
        }
    }
    this.geraZipArquivoRCI(zip, itemA);
  }

  async baixarArquivosSemRCI(itemA) {
    const zip: JSZip = new JSZip();
    this.blockUi.start('Carregando...');
  
    for (let i = 0; i < itemA.value.length; i++) {
      const anexoRci = itemA.value[i].noAnexo.substr(0,3).toUpperCase();
        if(anexoRci != 'RCI'){
        const documentoRetorno: any = await this.administrativoService.downloadDocumento(Number(itemA.value[i].tpReuniao), itemA.value[i].sqReuniao, itemA.value[i].sqAnexo);
        zip.file(itemA.value[i].dsAnexo, documentoRetorno, { base64: true });  
        }
    }
    this.geraZipArquivoRCI(zip, itemA);
  }

  private geraZipArquivoRCI(zip, itemA){

    if(Object.keys(zip.files).length > 0){
      zip.generateAsync({ type: 'blob' })
      .then(function (content) {
        FileSaver.saveAs(content, itemA.key);
      }).then(() => this.blockUi.stop()).catch(() => this.blockUi.stop())
    }else{
      this.blockUi.stop();
      this.toastrService.warning('Não há documento RCI para essa reunião', 'Atenção', { timeOut: 2000 })
    }
  }

 


  private _popularTabelaTela(reuniaoModel: ReuniaoModel): void {



    this.telaTabela.push({ id: Number(reuniaoModel.nrReuniao), key: `Reunião ${reuniaoModel.nrReuniao} de ${reuniaoModel.dtReuniao}`, value: this.anexoReuniaoModel, nrOrdenacao: reuniaoModel.nrOrdenacao });

    this.telaTabela = this._ordenaListaPagina(this.telaTabela);

    this.telaTabela.reverse();

  }

  async baixarDocumento(anexoReuniaoModel: AnexoReuniaoModel) {
    const documentoRetorno = await this.administrativoService.downloadDocumento(Number(anexoReuniaoModel.tpReuniao), anexoReuniaoModel.sqReuniao, anexoReuniaoModel.sqAnexo);
    // console.log(`documentoRetorno `, documentoRetorno['size']);
    if (documentoRetorno['size'] <= 0) {
      this.toastrService.info(`Este documento nao pode ser baixado, lamentamos o inconveniente.`);
      return;
    }
    this.administrativoService.handleFile(documentoRetorno, anexoReuniaoModel.noAnexo)

  }



  private _ordenaListaPagina(listaOrdena) {
    return listaOrdena.sort(function (a, b) {
      if (a.nrOrdenacao > b.nrOrdenacao) {
        return 1;
      }
      if (a.nrOrdenacao < b.nrOrdenacao) {
        return -1;
      }
      return 0;
    });
  }

  private _ordenaListaConteudo(listaOrdena) {
    return listaOrdena.sort(function (a, b) {
      if (a.dsAnexo > b.dsAnexo) {
        return 1;
      }
      if (a.dsAnexo < b.dsAnexo) {
        return -1;
      }
      return 0;
    });
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/administrativo/pautas-reunioes/pautas-reunioes.component.ts